import { Button, Form, Input, Modal } from "antd";
import { enqueueSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { AddIpAddress, UpdateIPAddress, axiosErrorMessages } from "../../../API/api";
import axios, { AxiosError } from "axios";
interface AddEditCategoryType {
  editData: any;
  isEdit: boolean;
  handleCloseAddEdit: (data: boolean) => void;

}
const AddNewIp: React.FC<AddEditCategoryType> = ({ editData, isEdit, handleCloseAddEdit }) => {

  const [isOpen, setIsOpen] = useState<boolean>(true)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [addLicenseForm] = Form.useForm()
  useEffect(() => {
    if (isEdit) {
      setFormData()
    }
  }, [])
  const setFormData = () => {
    addLicenseForm.setFieldsValue({
      ipaddress: editData.ipAddress
    })
  }
  const onClosePopup = () => { setIsOpen(false); handleCloseAddEdit(true) }
  const onIpStatusHandler = (formData: any) => {
    if (formData.ipaddress.trim()) {
      if (!isEdit) {
        AddIpAddress(formData.ipaddress.trim())
          .then((response: any) => {
            enqueueSnackbar("Added Successfully", {
              variant: "success",
              anchorOrigin: {
                vertical: "top",
                horizontal: "right",
              },
            });
            setIsOpen(false);
            handleCloseAddEdit(true)
            setIsLoading(false)

          })
          .catch((error: any) => {
            if (error.response.data.errors.ipAddress[0]) {
              enqueueSnackbar(error.response.data.errors.ipAddress[0], {
                variant: "error",
                anchorOrigin: {
                  vertical: "top",
                  horizontal: "right",
                },
              });
            } else {
              let errorMsg;
              if (axios.isAxiosError(error)) {
                const axiosError = error as AxiosError;
                errorMsg = axiosErrorMessages(axiosError);
              } else {
                errorMsg = error.message;
              }
              enqueueSnackbar(errorMsg, {
                variant: "error",
                anchorOrigin: {
                  vertical: "top",
                  horizontal: "right",
                },
              });
            }

            setIsLoading(false)

          })
      } else {
        UpdateIPAddress(editData.key, formData.ipaddress.trim())
          .then((response: any) => {
            enqueueSnackbar("Updated Successfully", {
              variant: "success",
              anchorOrigin: {
                vertical: "top",
                horizontal: "right",
              },
            });
            setIsOpen(false);
            handleCloseAddEdit(true)
            setIsLoading(false)

          })
          .catch((error: any) => {
            if (error.response.data.errors.ipAddress[0]) {
              enqueueSnackbar(error.response.data.errors.ipAddress[0], {
                variant: "error",
                anchorOrigin: {
                  vertical: "top",
                  horizontal: "right",
                },
              });
            } else {
              let errorMsg;
              if (axios.isAxiosError(error)) {
                const axiosError = error as AxiosError;
                errorMsg = axiosErrorMessages(axiosError);
              } else {
                errorMsg = error.message;
              }
              enqueueSnackbar(errorMsg, {
                variant: "error",
                anchorOrigin: {
                  vertical: "top",
                  horizontal: "right",
                },
              });
            }

            setIsLoading(false)

          })
      }
    } else
      enqueueSnackbar("Enter IP", {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });


  }
  return <>
    <Modal
      maskClosable={false}
      footer={null}
      title="Add New IP"
      onCancel={onClosePopup}
      open={isOpen}
    >

      <br />

      <Form
        name="basic"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 12 }}
        style={{ maxWidth: 1000 }}
        onFinish={onIpStatusHandler}
        autoComplete="off"
        form={addLicenseForm}
      >
        <Form.Item
          rules={[{ required: true, message: "Enter IP" }]}
          name="ipaddress"
        >
          <Input
            className="input-edit"
            placeholder="Enter IP Address"
          />

        </Form.Item>
        <Button className="pm-btn" type="primary" htmlType="submit">
          Save
        </Button>
        {isEdit && <Button className="pm-btn" type="primary" onClick={setFormData} style={{ marginLeft: '10px' }}>
          Reset
        </Button>}
      </Form>
    </Modal>
  </>
}

export default AddNewIp;